import { AwardIcon } from "lucide-react";

import { Certification } from "./Certification";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { SheetSectionHeader } from "@/components/SheetSectionHeader";
import { CertificationType } from "@/types";

export const CertificationSheetContent = ({
  certifications,
}: {
  certifications: CertificationType[];
}) => {
  /* Render */
  const renderContent = () => {
    if (!certifications.length) {
      return (
        <SheetSectionEmptyText text="This candidate hasn't added any certifications." />
      );
    }

    return (
      <Column className="gap-4">
        {certifications.map((certification) => (
          <Certification certification={certification} key={certification.id} />
        ))}
      </Column>
    );
  };

  const render = () => {
    return (
      <Column className="gap-6 border-t border-slate-200 py-6">
        <Row className="items-center justify-between">
          <SheetSectionHeader
            icon={AwardIcon}
            title="Certifications / Licenses"
          />
        </Row>
        {renderContent()}
      </Column>
    );
  };

  return render();
};
